/**
 * get-documents.js starts
 * Created by mac on 2019-01-29.
 */

$(function () {

  $(document).on('click', '.get-docs', function(e){
    var sessid = BX.bitrix_sessid(),
        orderid = e.currentTarget.dataset.orderid;
    
    var confirm = {
      title: "Вы действительно желаете получить документы?"
    };
    var confirmModel = new KApp.Models.ConfirmModel(confirm);
    confirmModel.confirmCallback = function(){
      $.ajax({
        url: "/ajax/order_documents.php",
        method: "post",
        data: {
          sessid: sessid,
          id: orderid
        },
        success: function(res){
          console.log(res);
          var result = {};
          if (res.success){
            result.status = 'success';
            result.title = 'Успех';
            result.message = 'Документы будут отправлены на ваш email'
          }
          
          var infoData  = new KApp.Models.InfoMessageModel(result),
              infoPopup = new KApp.Views.Modal({model: infoData});
          setTimeout(function(){
            $.magnificPopup.close();
          }, 3000);
        },
        error: function(err){
          console.log(err);
        }
      });
    };
    var confirmView = new KApp.Views.ConfirmModal({model: confirmModel});
    e.preventDefault();
  });
});

/* get-documents.js ends */